import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

interface SearchBarProps {
  defaultValue?: string;
  placeholder?: string;
  size?: 'sm' | 'lg';
  onSearch?: (keyword: string) => void;
  autoFocus?: boolean;
}

export default function SearchBar({
  defaultValue = '',
  placeholder = '搜索剧名、演员或资讯关键词…',
  size = 'sm',
  onSearch,
  autoFocus = false,
}: SearchBarProps) {
  const [keyword, setKeyword] = useState(defaultValue);
  const navigate = useNavigate();

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = keyword.trim();
    if (onSearch) {
      onSearch(value);
      return;
    }
    if (!value) {
      navigate('/search');
      return;
    }
    navigate(`/search?q=${encodeURIComponent(value)}`);
  };

  const isLarge = size === 'lg';

  return (
    <form
      onSubmit={handleSubmit}
      role="search"
      className={`flex items-center w-full bg-background-50 border border-background-300 rounded-full overflow-hidden focus-within:border-primary-400 transition-colors ${
        isLarge ? 'h-12' : 'h-10'
      }`}
    >
      <span className={`flex items-center justify-center text-foreground-500 ${isLarge ? 'w-12 h-12' : 'w-10 h-10'}`}>
        <i className="ri-search-line"></i>
      </span>
      <input
        type="text"
        name="keyword"
        value={keyword}
        autoFocus={autoFocus}
        onChange={(event) => setKeyword(event.target.value)}
        placeholder={placeholder}
        aria-label="搜索"
        className={`flex-1 bg-transparent outline-none text-foreground-900 placeholder:text-foreground-400 ${isLarge ? 'text-base' : 'text-sm'}`}
      />
      <button
        type="submit"
        className={`shrink-0 bg-accent-500 text-background-50 dark:text-foreground-950 font-label font-medium hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap ${
          isLarge ? 'h-12 px-6 text-sm' : 'h-10 px-4 text-sm'
        }`}
      >
        搜索
      </button>
    </form>
  );
}